import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(cents: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(cents / 100)
}

export function formatCents(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`
}

export function formatDate(date: string): string {
  if (!date) return ''
  return new Date(date).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  })
}

// Rails serializes Date values as YYYY-MM-DD. Parsing that shape with
// `new Date(value)` treats it as UTC and can display the previous day west of
// UTC. Build a local calendar date instead; timestamps should keep using
// formatDate above.
export function formatDateOnly(date: string): string {
  if (!date) return ''

  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date)
  if (!match) return formatDate(date)

  const [, year, month, day] = match
  return new Date(Number(year), Number(month) - 1, Number(day)).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}

// Inertia's onError callback can hand back either a single message or an
// array of them per field — this normalizes to one string for display.
export function firstError(value: string | string[] | undefined): string | undefined {
  return Array.isArray(value) ? value[0] : value
}
